export function encodeQuery(query: any) {
  const d = new URLSearchParams(query as Record<string, string>)
  return d.toString()
}
